<mat-sidenav-container class="mainWrapper" autosize autoFocus [ngClass]="{
    'sidebarNav-mini': options.sidenavCollapsed && options.navPos !== 'top' &&  !resView,
    'sidebarNav-horizontal': options.horizontal,
    cardBorder: options.cardBorder,
  }" [dir]="options.dir!">
  <!-- ============================================================== -->
  <!-- Vertical Sidebar (desktop only; responsive uses drawer below) -->
  <!-- ============================================================== -->
  @if (!options.horizontal && !resView) {
  <mat-sidenav #leftsidenav [mode]="isOver ? 'over' : 'side'" [opened]="
      options.navPos === 'side' && options.sidenavOpened && !isOver && !resView
    " (openedChange)="onSidenavOpenedChange($event)" (closedStart)="onSidenavClosedStart()" class="sidebarNav">
    <div class="flex-layout">
      <app-sidebar (toggleMobileNav)="sidenav.toggle()" [showToggle]="isOver"></app-sidebar>
      <ng-scrollbar class="position-relative" style="height: 100%">
        <mat-nav-list class="sidebar-list">
          @for(item of visibleNavItems(); track item.route ?? item.navCap ?? item.displayName ?? $index) {
          <app-nav-item [item]="item" (notify)="sidenav.toggle()" class="top-parent">
          </app-nav-item>
          }
        </mat-nav-list>
      </ng-scrollbar>
      <app-version></app-version>
    </div>
  </mat-sidenav>
  }

  <!-- ============================================================== -->
  <!-- Responsive / overlay Sidebar (one start drawer when resView) -->
  <!-- ============================================================== -->
  @if (resView) {
  <mat-sidenav #leftsidenav position="start" [mode]="'over'" [opened]="options.sidenavOpened && !isTablet"
    (openedChange)="onSidenavOpenedChange($event)" (closedStart)="onSidenavClosedStart()" class="sidebarNav">
    <!-- Same flex-layout wrapper as the desktop sidenav, so the build stamp
         stays pinned at the bottom instead of overflowing below the drawer. -->
    <div class="flex-layout">
      <app-sidebar> </app-sidebar>
      <ng-scrollbar class="position-relative" style="height: 100%">
        <mat-nav-list class="sidebar-list">
          @for(item of visibleNavItems(); track item.route ?? item.navCap ?? item.displayName ?? $index) {
          <app-nav-item [item]="item" (notify)="sidenav.toggle()"> </app-nav-item>
          }
        </mat-nav-list>
      </ng-scrollbar>
      <app-version></app-version>
    </div>
  </mat-sidenav>
  }

  <!-- ============================================================== -->
  <!-- Main Content -->
  <!-- ============================================================== -->
  <mat-sidenav-content class="contentWrapper" #content>
    <!-- ============================================================== -->
    <!-- VerticalHeader -->
    <!-- ============================================================== -->
    @if (!options.horizontal || resView) {
    <app-header [showToggle]="!isOver" (toggleCollapsed)="toggleCollapsed()" (toggleMobileNav)="sidenav.toggle()"
      (searchOverlayActiveChange)="searchOverlayActiveChange($event)"
      (toggleMobileFilterNav)="isFilterNavOpen = !isFilterNavOpen"
      (optionsChange)="receiveOptions($event)"></app-header>
    } @else {
    <!-- horizontal header -->
    <app-horizontal-header (toggleMobileNav)="sidenav.toggle()"
      (toggleMobileFilterNav)="isFilterNavOpen = !isFilterNavOpen"
      (searchOverlayActiveChange)="searchOverlayActiveChange($event)"
      (optionsChange)="receiveOptions($event)"></app-horizontal-header>
    } @if(options.horizontal) {
    <app-horizontal-sidebar></app-horizontal-sidebar>
    }
    <div class="body-wrapper">
      <main class="pageWrapper" [ngClass]="{
          maxWidth: options.boxed
        }">
        <app-breadcrumb></app-breadcrumb>
        <!-- ============================================================== -->
        <!-- Outlet -->
        <!-- ============================================================== -->
        <router-outlet></router-outlet>

        <!--<div class="customizerBtn">
          <button mat-fab class="bg-error text-white" (click)="customizerRight.toggle()">
            <mat-icon>settings</mat-icon>
          </button>
        </div>-->

      </main>
    </div>
  </mat-sidenav-content>

  <mat-sidenav #customizerRight mode="over" position="end" class="customizerNav">
    <div class="p-x-16 p-y-20 d-flex align-items-center justify-content-between b-b-1">
      <h3 class="f-s-21 f-w-600">Settings</h3>

      <a mat-icon-button (click)="customizerRight.toggle()" class="d-flex justify-content-center">
        <mat-icon>close</mat-icon>
      </a>
    </div>

    <app-customizer (optionsChange)="receiveOptions($event)"></app-customizer>
  </mat-sidenav>
</mat-sidenav-container>

<!-- ------------------------------------------------------------------
  Mobile Apps Sidebar
  ------------------------------------------------------------------ -->
<div #filterNavRight [hidden]="!isFilterNavOpen" class="filter-sidebar">
  <div>
    <div class="d-flex justify-content-between align-items-center">
      <div class="branding">
        <app-branding></app-branding>
      </div>
      <button mat-icon-button (click)="isFilterNavOpen = !isFilterNavOpen" class="d-flex justify-content-center">
        <i-tabler name="x" class="icon-18 d-flex"></i-tabler>
      </button>
    </div>

    <mat-accordion>
      <mat-expansion-panel class="shadow-none">
        <mat-expansion-panel-header>
          <mat-panel-title class="f-s-16 f-w-500"> Apps </mat-panel-title>
        </mat-expansion-panel-header>
        <div>
          <div class="row">
            @for(appdd of apps; track appdd.title) {
            <div class="col-12 text-hover-primary">
              <a [routerLink]="[appdd.link]" class="d-flex align-items-center text-decoration-none m-b-24 gap-16">
                <span class="text-{{ appdd.color }} bg-light-{{
                    appdd.color
                  }} rounded icon-48 d-flex align-items-center justify-content-center">
                  <span class="iconify icon-20" [attr.data-icon]="appdd.icon"></span>
                </span>

                <div class="m-l-16">
                  <h5 class="f-s-14 f-w-600 m-0 hover-text">
                    {{ appdd.title }}
                  </h5>
                  <span class="f-s-12 text-muted">{{ appdd.subtitle }}</span>
                </div>
              </a>
            </div>
            }
          </div>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
</div>

<app-search [searchOverlayActive]="searchOverlayActive"
  (searchOverlayActiveChange)="searchOverlayActiveChange($event)"></app-search>
<ng-container *ngIf="helperService.isLoading$ | async as isLoading">
  <app-load-spinner *ngIf="isLoading"></app-load-spinner>
</ng-container>

<faq-chat-widget
  api-url="/api/Faq_bridge"
  adapter="arturpro"
  locale="en"
  [attr.pathname]="activeFaqRoute()"
  [attr.faq-id]="activeFaqId()"
></faq-chat-widget>